
import { useState } from "react";
import { MessageSquare, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ChatInterface } from "./ChatInterface";
import { ResponseFormattingProvider } from "./formatting/ResponseFormattingContext";

export function ChatButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isOpen && (
        <div className="absolute bottom-0 right-0 animate-fade-in">
          <ResponseFormattingProvider>
            <ChatInterface onClose={() => setIsOpen(false)} />
          </ResponseFormattingProvider>
        </div>
      )}
      
      <Button 
        onClick={() => setIsOpen(!isOpen)} 
        size="icon" 
        className={`h-12 w-12 rounded-full shadow-lg transition-transform hover:scale-105 ${
          isOpen ? 'bg-muted hover:bg-muted' : ''
        }`}
      >
        {isOpen ? <X className="h-5 w-5" /> : <MessageSquare className="h-5 w-5" />}
        <span className="sr-only">
          {isOpen ? "Close chat" : "Open chat"}
        </span>
      </Button>
    </div>
  );
}
